import { useCallback, useEffect } from "react";
import { useSelector } from "react-redux";

import { CheckoutSteps } from "@utils/enums";

import { useThunkDispatch } from "@redux/dispatcher";
import * as CartModule from "@redux/modules/api/data/cart/cart.module";
import * as CartSelectors from "@redux/modules/api/data/cart/cart.selectors";

export const useCheckout = () => {
    const dispatch = useThunkDispatch();

    const cart = useSelector(CartSelectors.getCart);
    const cartError = useSelector(CartSelectors.getCartError);
    const cartLoading = useSelector(CartSelectors.isLoadingCart);
    const cartLoadedSuccessfully = useSelector(
        CartSelectors.isSuccessfullyLoaded,
    );

    const validateCheckoutStep = useCallback(
        (checkoutStep: CheckoutSteps, force: boolean) =>
            dispatch(CartModule.validateCheckoutStep(checkoutStep, force)),
        [dispatch, cart, cartLoading],
    );

    useEffect(() => {
        dispatch(CartModule.load());
    }, [dispatch]);

    return {
        cart: cart ?? undefined,
        cartError: cartError,
        cartLoading: cartLoading,
        cartLoadedSuccessfully: cartLoadedSuccessfully,
        validateCheckoutStep: validateCheckoutStep,
    };
};
